import { createContext } from 'react'

// A tree with no <IntlProvider> above it, or one whose provider was never
// asked to wait, has nothing to withhold a frame for.
export default createContext(true)
